var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component } from "vue-facing-decorator";
import { Action } from "vuex-facing-decorator";
import { AuthClient } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { CryptoHelper } from "@/app/utils/crypto-helper";
import * as Sentry from "@sentry/vue";
const loginNamespace = "loginModule";
const authClient = new AuthClient(window.apiUrl);
const userTokenKey = window.userTokenKey;
let SsoCallbackVue = class SsoCallbackVue extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.hasError = false;
        this.errorMessage = "";
        this.statusMessage = "Signing In";
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            try {
                // Call the SSO callback endpoint to get the user auth state
                const auth = yield authClient.ssoCallback(this.returnUrl, this.companyId);
                if (!auth || !auth.authenticated) {
                    throw new Error("Authentication failed");
                }
                // Store the auth state in localStorage (same as regular login)
                console.log('auth', auth);
                localStorage.setItem(userTokenKey, CryptoHelper.encryptSync(JSON.stringify(auth)));
                // Set Sentry user context
                Sentry.setUser({
                    id: (_a = auth === null || auth === void 0 ? void 0 : auth.user) === null || _a === void 0 ? void 0 : _a.userId.toString(),
                    username: ((_b = auth === null || auth === void 0 ? void 0 : auth.user) === null || _b === void 0 ? void 0 : _b.userName) || "",
                    email: ((_c = auth === null || auth === void 0 ? void 0 : auth.user) === null || _c === void 0 ? void 0 : _c.emailAddress) || ""
                });
                // Redirect to return URL or default page
                if (auth.requires2FA)
                    window.location.href = window.twoFactorAuthUrl;
                else {
                    const redirectUrl = this.returnUrl || window.baseUrl;
                    window.location.href = decodeURIComponent(redirectUrl);
                }
            }
            catch (ex) {
                console.error("SSO callback error:", ex);
                this.hasError = true;
                this.isLoading = false;
                this.errorMessage = ex.message || "An error occurred during SSO authentication";
                this.statusMessage = "Sign In Failed";
                Notifier.onError(this.errorMessage);
            }
        });
    }
    get returnUrl() {
        const query = this.$route.query;
        if (!query || !query.returnUrl || typeof query.returnUrl !== 'string')
            return "";
        return query.returnUrl;
    }
    get companyId() {
        const query = this.$route.query;
        if (!query || !query.companyId || typeof query.companyId !== 'string')
            return "";
        return query.companyId;
    }
};
__decorate([
    Action("loginSuccess", { namespace: loginNamespace }),
    __metadata("design:type", Object)
], SsoCallbackVue.prototype, "loginSuccess", void 0);
SsoCallbackVue = __decorate([
    Component({
        name: "SsoCallbackVue"
    })
], SsoCallbackVue);
export default SsoCallbackVue;
